import {CommonService} from '../../services/common.service';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SimpleConfirmActionDialogComponent} from '../../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {SparePartFormComponent} from './spare-part-form/spare-part-form.component';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {
  CdkDragDrop,
  CdkDropList,
  CdkDragPreview,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
interface Model {
  id: number;
  name: string;
}

interface SparePart {
  alternate_id: string;
  category_description: string;
  category_id: number;
  description: string;
  id: number;
  measurement_unit: string;
  model_description: string;
  model_id: string;
  position: number;
}

@Component({
  selector: 'app-spare-parts',
  templateUrl: './spare-parts.component.html'
})
export class SparePartsComponent implements OnInit {
  models: Model[];
  selectedModel: Model;
  spareParts: MatTableDataSource<SparePart> = new MatTableDataSource<SparePart>();
  displayPartColumns = ['id', 'alternate_id', 'description', 'category_description', 'measurement_unit', 'actions'];
  loading: boolean;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService,
              private cdRef: ChangeDetectorRef) {
    this.loading = false;
  }

  public async ngOnInit(): Promise<any> {
    await this.initModels();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  async drop(event: CdkDragDrop<string[]>) {
    try {
      if (this.spareParts.data.length > 0) {
        // const previousIndex = this.spareParts.data.findIndex(row => row === event.item.data);
        moveItemInArray(this.spareParts.data, event.previousIndex, event.currentIndex);
        const row = this.spareParts.data[event.currentIndex];
        const array = [];
        this.spareParts.data = [...this.spareParts.data];
        for (const item of this.spareParts.data) {
          const object = {
            id: item.id,
            position: this.spareParts.data.indexOf(item)
          };
          array.push(object);
        }
        console.log(array);
        await this.updatePosition(array);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async initModels() {
    try {
      this.models = await this.commonService.getList('model') as Model[];
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initSpareParts(id: number) {
    try {
      this.loading = true;
      const partsRequest = await this.commonService.getListWithParameters(`repair_spare_parts`, `model_id=${id}`) as SparePart[];
      return partsRequest;
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  applyFilter(filterValue: string) {
    this.spareParts.filter = filterValue.trim().toLowerCase();
  }

  async updatePosition(data) {
    try {
      await this.commonService.updateObject('repair_spare_parts', {
          data
        });
      this.spareParts = new MatTableDataSource<SparePart>(await this.initSpareParts(this.selectedModel.id));
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async modelChanged() {
    try {
      this.spareParts = new MatTableDataSource<SparePart>();
      this.spareParts = new MatTableDataSource<SparePart>(await this.initSpareParts(this.selectedModel.id));
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  showPartsDialog(mode: number, part?: SparePart) {
    const dialog = this.matDialog.open(SparePartFormComponent, {
      width: '450',
      data: {
        edit: mode === 1,
        part
      }
    });

    dialog.afterClosed().subscribe(async (result) => {

      if (result) {
        if (mode === 0) {
          result.model_id = this.selectedModel.id;
          try {
            await this.commonService.insertItem('repair_spare_parts', result);
            this.toastMessagesService.toastInsertSuccess();
            await this.modelChanged();
          } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
          }
        } else {
          try {
            await this.commonService.updateObject('repair_spare_parts', result);
            this.toastMessagesService.toastUpdateSuccess();
            await this.modelChanged();
          } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
          }
        }
      }

    });
  }

  showConfirmDeleteDialog(part: SparePart) {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: `Διαγραφή ${part.description} ανταλλακτικού`,
        message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το ανταλλακτικό'
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.deleteItemWithParam(`repair_spare_parts/${part.id}`);
          this.toastMessagesService.toastDeleteSuccess();
          await this.modelChanged();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }


}
